import React, { useEffect, useState, useRef } from 'react'

const Alert = props => {
  const [alertClassName, setAlertClassName] = useState()

  const alertRef = useRef()
  const timerRef = useRef(null)

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      props.onHide()
    }, 3000)

    return () => { clearTimeout(timerRef.current) }
  }, [])

  useEffect(() => {
    setAlertClassName(props.className)

    const handleAnimationEnd = () => { if (props.className === 'close-alert') { props.onRemove() } }

    alertRef.current.addEventListener('animationend', handleAnimationEnd, { once: true })

    return () => { alertRef.current?.removeEventListener('animationend', handleAnimationEnd) }
  }, [props.className])

  return (
    <div id='landing-alert' ref={alertRef} className={alertClassName}>
      {props.text}
    </div>
  )
}

export default Alert
